export { ResetPassword as default } from "./reset-password";
